import type { Tank } from "./api";

export const LABEL_MAX = 80;
export const LABEL_LENGTH = `A container name has 1 to ${LABEL_MAX} characters.`;

export const cleanLabel = (raw: string) => raw.split(/\s+/).filter(Boolean).join(" ");

export function labelError(raw: string): string | null {
  const label = cleanLabel(raw);
  const length = [...label].length;
  if (length < 1 || length > LABEL_MAX) return LABEL_LENGTH;
  if (/\p{C}/u.test(label)) return "A container name cannot contain control characters.";
  return null;
}

export type Undo = { kind: "rename"; label: string } | { kind: "reset" };

export function undoFor(before: Pick<Tank, "label" | "label_from">): Undo {
  return before.label_from === "user" ? { kind: "rename", label: before.label } : { kind: "reset" };
}

/** Where the name of the tank comes from. Only a Particle device has a name sync. */
export function labelFromText(tank: Pick<Tank, "label_from" | "devices">): string {
  if (tank.label_from === "default") return "The name comes from the device ID.";
  if (tank.label_from === "user") return "A person gave this name. The device sync does not change it.";
  return tank.devices.some((device) => device.startsWith("particle "))
    ? "The name comes from the Particle device. A sync keeps it up to date."
    : "The name comes from the device.";
}
